import { atom } from "recoil";

// 채널톡 상담창(메신저)이 열려 있는지.
// 자체 플로팅 런처의 아이콘(말풍선 ↔ X)이 이 값을 본다. 상담창 안의 닫기 버튼이나
// 다른 화면의 showMessenger() 로 열고 닫아도 SDK 콜백이 이 값을 갱신한다.
export const channelTalkMessengerOpenState = atom<boolean>({
  key: "channelTalkMessengerOpenState",
  default: false,
});

// 채널톡 boot 이 끝나 SDK 호출이 먹히는 상태인지.
// boot 은 /users/me 응답이 온 뒤에야 실행되므로, 그 전에 누른 클릭은 그냥 무시된다.
// useOpenChannelTalk 이 이 값을 보고 "준비되면 열기"로 예약한다.
export const channelTalkBootedState = atom<boolean>({
  key: "channelTalkBootedState",
  default: false,
});

// boot 전에 누른 "상담창 열기"를 기억해 두는 값. boot 이 끝나면 useChannelTalkBoot 가 대신 연다.
export const channelTalkPendingOpenState = atom<boolean>({
  key: "channelTalkPendingOpenState",
  default: false,
});

// 안 읽은 메시지 수. 채널톡 기본 런처를 감췄으니 뱃지도 직접 그린다.
export const channelTalkUnreadState = atom<number>({
  key: "channelTalkUnreadState",
  default: 0,
});
